export const SERVICE_TYPE = {
  L: 'L',
  P: 'P',
  E: 'E'
}
